import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as urlParse from 'url-parse';
import { environment } from '../../../environments/environment';
import { AppApiEndpoints } from '../../app.api.endpoints';
import { UrlObject } from '../../models/urlobject';


@Injectable()
export class HelperProvider {
	public promoStartDate: any;
	public promoEndDate: any;

	constructor() {
		if (environment.PROMO_START) {
			this.promoStartDate = moment(environment.PROMO_START);
		} else {
			console.error('MISSING ENV VARIABLE "PROMO_START"');
		}

		if (environment.PROMO_END) {
			this.promoEndDate = moment(environment.PROMO_END);
		} else {
			console.error('MISSING ENV VARIABLE "PROMO_END"');
		}
	}

	public isInPromoPeriod() {
		console.log('start', this.promoStartDate.format('YYYY-MM-DD'));
		console.log('end', this.promoEndDate.format('YYYY-MM-DD'));

		return moment().isBetween(this.promoStartDate, this.promoEndDate, null, '[)');
	}

	public parseUrl(url: string, parseQuery= true): UrlObject {
		return urlParse(url, parseQuery);
	}


	public getNodeByUrl(url: string) {

		const parsedUrl = this.parseUrl(url);
		const pathRegex = new RegExp('^' + environment.API_URL);

		const pathName = parsedUrl.pathname.replace(pathRegex, '');
		const apiEndpoints = AppApiEndpoints.nodes;

		const nodeName = Object.keys(apiEndpoints).find((node) => apiEndpoints[node].url === pathName);

		if (nodeName) {
			return apiEndpoints[nodeName];
		}

		return false;

	}
}



// WEBPACK FOOTER //
// ./src/app/core/providers/helper.ts